import { render, staticRenderFns } from "./DoPractice.vue?vue&type=template&id=66e9e5c3&scoped=true&"
import script from "./DoPractice.vue?vue&type=script&lang=js&"
export * from "./DoPractice.vue?vue&type=script&lang=js&"
import style0 from "./DoPractice.vue?vue&type=style&index=0&id=66e9e5c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9e5c3",
  null
  
)

export default component.exports